/**
 * Clés de cache du domaine `notifications` — les réglages d'e-mails de
 * l'utilisateur (`/settings/notifications`).
 *
 * Voir `src/hooks/profile/keys.ts` pour le pourquoi de la fabrique.
 */
export const notificationKeys = {
  all: ['notifications'] as const,

  /** `GET /settings/notifications`. */
  settings: () => [...notificationKeys.all, 'settings'] as const,

  mutations: () => [...notificationKeys.all, 'mutation'] as const,
} as const;
